export const BookingPathKeys = {
    basePath: 'basePath',
    startSignInPath: 'startSignInPath',
    createAccountPath: 'createAccountPath',
    selectPatientPath: 'selectPatientPath',
    appointmentInfoPath: 'appointmentInfoPath',
    lightningPath: 'lightningPath',
    phoneVerificationPath: 'phoneVerificationPath',
    phoneEntryPath: 'phoneEntryPath',
    appointmentDetailsPath: 'appointmentDetailsPath',
    bookingCompletePath: 'bookingCompletePath',
    legacySyncPath: 'legacySyncPath',
    medicalTeamPath: 'medicalTeamPath',
};

export const basePath = '/booking';

export const paths = {
    [BookingPathKeys.basePath]: basePath,
    [BookingPathKeys.startSignInPath]: `${basePath}/startsignin`,
    [BookingPathKeys.createAccountPath]: `${basePath}/createaccount`,
    [BookingPathKeys.selectPatientPath]: `${basePath}/patient`,
    [BookingPathKeys.appointmentInfoPath]: `${basePath}/start`,
    [BookingPathKeys.lightningPath]: `${basePath}/reviewandbook`,
    [BookingPathKeys.phoneVerificationPath]: `${basePath}/verify`,
    [BookingPathKeys.phoneEntryPath]: `${basePath}/phoneentry`,
    [BookingPathKeys.appointmentDetailsPath]: `${basePath}/review`,
    [BookingPathKeys.bookingCompletePath]: `${basePath}/complete`,

    // legacy paths left here for ab experiments
    [BookingPathKeys.legacySyncPath]: `${basePath}/sync`,

    // paths outside of booking flow
    [BookingPathKeys.medicalTeamPath]: '/patient/medicalteam',
};

export const BASE_BOOKING_GA_CATEGORY = 'Booking';

export const BOOKING_GA_CATEGORIES = {
    [BookingPathKeys.basePath]: BASE_BOOKING_GA_CATEGORY,
    [BookingPathKeys.startSignInPath]: 'Booking - Sign In',
    [BookingPathKeys.createAccountPath]: 'Booking - Create Account',
    [BookingPathKeys.selectPatientPath]: 'Booking - Select Patient',
    [BookingPathKeys.appointmentInfoPath]: 'Booking - Review',
    [BookingPathKeys.lightningPath]: 'Booking - Lightning',
    [BookingPathKeys.phoneVerificationPath]: 'Booking - Phone Ver',
    [BookingPathKeys.phoneEntryPath]: BASE_BOOKING_GA_CATEGORY,
    [BookingPathKeys.appointmentDetailsPath]: 'Booking - Details',
    [BookingPathKeys.bookingCompletePath]: 'Booking - Booking Complete',
    [BookingPathKeys.legacySyncPath]: '',
    [BookingPathKeys.medicalTeamPath]: '',
};
